import type { FC } from 'react';
import { memo } from 'react';
import { Picture } from '@ui';
import icons from '@icons';
import { yandexR, gisR } from '@images';
import { useOrganizationRatingQuery } from '@queries/index';
import { preparePriceFloatObject } from '@utils/floatNumbers';

const {
  star: { midYellow: starMYFilled }
} = icons.Fill;

const ratingConfig = {
  yandex: {
    icon: yandexR,
    iconWidth: 83,
    iconHeight: 18,
    link:
      'https://yandex.ru/maps/213/moscow/?ll=37.850156%2C55.647998&mode=poi&poi%5Bpoint%5D=37.849149%2C55.648555&' +
      'poi%5Buri%5D=ymapsbm1%3A%2F%2Forg%3Foid%3D1091018457&tab=reviews&utm_source=share&z=18'
  },
  '2gis': {
    icon: gisR,
    iconWidth: 56,
    iconHeight: 18,
    link: 'https://2gis.ru/moscow/search/%D0%94%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%B5%D1%81%D0%BA%D0%B0?m=37.6068%2C55.738823%2F10.72'
  }
};

interface FooterRatingProps {
  type?: '2gis' | 'yandex';
}

const FooterRating: FC<FooterRatingProps> = ({ type = 'yandex' }) => {
  // Общий кэш с рейтингом в шапке
  const { data } = useOrganizationRatingQuery();

  const rating = data?.getOrganizationRating ?? null;

  if (typeof rating !== 'number') {
    return (
      <div
        className='footer-rating footer-rating--placeholder'
        aria-hidden='true'
      >
        <div className='footer-rating-link' />
      </div>
    );
  }

  const floatRating = preparePriceFloatObject(rating);
  const config = ratingConfig[type];

  if (!config) {
    return null;
  }

  return (
    <div className='footer-rating'>
      <a
        target='_blank'
        rel='noreferrer'
        href={config.link}
        className='footer-rating-link'
      >
        <Picture icon={starMYFilled} height='16' width='16' />
        <span className='footer-rating-text'>
          {floatRating.wholePart}
          {floatRating.floatPart ? `,${floatRating.floatPart}` : null}
        </span>
        <Picture
          icon={config.icon}
          height={config.iconHeight}
          width={config.iconWidth}
        />
      </a>
    </div>
  );
};

export default memo(FooterRating);
